import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLogin } from "./features/Loginuser";


function PublicRoutes({ children }) {
  const login = useSelector(getLogin);

  if (login) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default PublicRoutes;
